import type { Component } from 'vue'

// Eager load frontend page components
const pageComponents = import.meta.glob<{ default: Component }>(
    '../components/frontend/Frontend*Page.vue',
    {
        eager: true,
        import: 'default'
    }
)

const pageRegistry = new Map<string, Component>()

// Build registry
Object.entries(pageComponents).forEach(([path, module]) => {
    const match = path.match(/Frontend([A-Za-z]+)Page\.vue$/)
    if (match) {
        const componentName = `Frontend${match[1]}Page`
        pageRegistry.set(componentName, module)
    }
})

export default function useFrontendPageRegistry() {
    function getPageComponent(name: string): Component | undefined {
        const component = pageRegistry.get(name)
        if (!component) {
            console.warn(`[Frontend Registry] Page component not found: ${name}`)
        }
        return component
    }

    return {
        getPageComponent,
    }
}
